import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { MetadataService } from '../../../_services/metadatas/metadata.service';
import IMetadata from '../../../_interfaces/IMetadata';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ErrorsService } from '../../../_services/errors/errors.service';
import { BaseComponent } from '../../base/base.component';
import { SessionService } from '../../../_services/session/session.service';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DeleteButtonMetadataPatientsComponent } from '../../delete-buttons/delete-button-metadata-patients/delete-button-metadata-patients.component';

@Component({
  standalone: true,
  selector: 'app-table-metadata-patients',
  templateUrl: './table-metadata-patients.component.html',
  styleUrls: ['./table-metadata-patients.component.scss'],
  imports: [
    TableModule,
    TranslatePipe,

    ButtonModule,
    DeleteButtonMetadataPatientsComponent,
  ],
})
export class TableMetadataPatientsComponent
  extends BaseComponent
  implements OnInit
{
  public patientsMetadata: IMetadata[];

  constructor(
    public metadataService: MetadataService,
    public session: SessionService
  ) {
    super(session);
  }

  onDelete = () => {
    this.load();
  };

  load() {
    this.metadataService
      .get(this.customers_id)
      .subscribe((metadata: IMetadata[]) => {
        this.patientsMetadata = metadata;
      });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.load();
  }
}
